import { useEffect, useState, useRef } from "react";
import Menus from "./menus"
import "../assets/css/utility.css"
import { commonAPI } from "../services/CommonAPIService";
import vehicleOwner from "../assets/img/fleet-management.png"
import ContactIcon from "../assets/img/supportIcon.png"
import manageRfid from "../assets/img/managerfid.png"
import noVehicle from "../assets/img/noVehicle.png"
import noVehicle_Two from "../assets/img/carmanage.png"
import { FiSearch } from "react-icons/fi";
import { FaRegEdit } from "react-icons/fa";
import { IconContext } from "react-icons";
import { ToastContainer, toast } from "react-toastify";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css'
import ManageVehicle from "./ManageVehicle";
import ManageRFID from "./ManageRFID"
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import "../assets/css/report.css";
import ManageTag from "./ManageTag";
import Select from "react-dropdown-select";
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
import PriorityContact from "./PriortyContact";

const Utility = () => {
    const history = useNavigate();
    const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)
    const inputData = useRef(null);
    const [vehicleDetail, setVehicleDetail] = useState()
    const [activeTab, setActiveTab] = useState("tab1");
    const [edit, setEdit] = useState(false)
    const [editFlat, setEditFlat] = useState(false)
    const [flat, setflat] = useState()
    const [myFlatName, setMyFlatName] = useState()
    const inputRef = useRef(null); // Create a ref for the input element
    const [flatId, setFlatIdOption] = useState()
    const [ownerName, setOwnerName] = useState()
    const [Loading, setLoading] = useState(false)
    const [TowerList, setTowerList] = useState("")
    const [TowerSelected, setTowerSelected] = useState("")
    const [TowerNameGet, setTowerNameGet] = useState("")
    // Focus the input field when `edit` is set to true
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const storedUsername = localStorage.getItem('userData');
        const myUserData = JSON.parse(storedUsername);
        console.log("useEffect Local storage name", storedUsername)
        if (storedUsername) {
            if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
                if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
                    history('/Utility');
                    return
                  }else{
                    history('/Dashboard');
                    return
                  }  
                
            }else{
                history('/Dashboard');
                console.log("useEffect Local storage Yes")
                return
            }  
        }
        else if (storedUsername === null) {
          history('/');
          console.log("useEffect Local storage No")
        }
    }, [history]);

    const handleTabChange = (tab) => {
        console.log("Initial Tab", tab)
        localStorage.setItem("lastTabUtility", tab)
        setActiveTab(tab);
      };

    useEffect(() => {
        localStorage.setItem("lastTabApproval", "tab1")
        localStorage.setItem("lastTabManagent", "tab1")
        const lastTab = localStorage.getItem("lastTabUtility");
        if (!lastTab) {
          setActiveTab("tab1")
        }
        else {
          console.log(lastTab, "lastTTT")
          setActiveTab(lastTab)
        }
    
      }, [])


    const mobileStyle = {
        backgroundColor: "#2e333f",
        marginTop: "56px",
        width: "100%",
    };

    // Function to update the state based on window width
    const handleResize = () => {
        if (window.innerWidth < 600) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };



    // useEffect to add and clean up the event listener
    useEffect(() => {
        // Add the event listener
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (edit && inputRef.current) {
            inputRef.current.focus();
        }
    }, [edit]);
    
    const [reset, setReset] = useState(0);

    const GetTowerList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            setLoading(true);
            let response = await commonAPI("Tower", undefined, endPointVariableKey)
            if (response?.success === true) {
                setTowerList(response?.data);
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Tower/",
                "errorNumber": "GT01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Resident.js",
                "functionName": "GetTowerList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const getFlatList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);

        // setLoading(true);
        const endPointVariableKey = {
            urlVariable: inputData?.current?.value,
            buildingId: myUserData?.buildingId,

        }
        // setLoading(true)
        try {
            const response = await commonAPI('Flat', undefined, endPointVariableKey)
            
            setLoading(false)
            if (response?.success === true) {
                if(TowerSelected){
                    const tempData = response?.data.filter((item) => item?.towerId == TowerSelected)
                    setflat(tempData);
                    setLoading(false);
                }else{
                    setflat(response?.data);
                    setLoading(false);
                }
                
               
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        }
        catch (error) {
            setLoading(false)
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Flat",
                "errorSource": "CuroNextPortal",
                "errorNumber": "UTI02",
                "errorSource": "CuroNextPortal",
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Utility.js",
                "functionName": "getFlatList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message.length == 0) {
                alert("Something went wrong");
                setLoading(false);
            } else {
                alert("Something went wrong");
                setLoading(false);
            }
        }

        //console.log(response)
    }
    useEffect(() => {
        GetTowerList();
        getFlatList()
    }, [])

    useEffect(() => {
        getFlatList()
    }, [TowerSelected])

    // useEffect(() => {
    //     if (flat?.length > 0 && vehicleDetail) {
    //         flatNumber();
    //     }
    // }, [flat, vehicleDetail]);

    // const flatNumber = () => {
    //     const flatName = flat?.filter((flatId) => {
    //         return vehicleDetail?.flatId === flatId?.flatId;
    //     });
    //     setMyFlatName(flatName);
    //     //console.log(flatName, "flatName");
    // };

    const getVehicleDetailByNum = async () => {
        if (!inputData.current.value) {
            toast.warning('Please enter full vehicle number');
            return

        }
        setEdit(false)
        setEditFlat(false)
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = { 
            "lpNumber":  inputData?.current.value,
        };
        // setLoading(true);
        const endPointVariableKey = {
            // urlVariable: inputData?.current.value,
            buildingId: myUserData?.buildingId,

        }

        setLoading(true)
        try {
            // const response = await commonAPI('mangeVehicleOwner', undefined, endPointVariableKey)
            let response = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
            console.log(response,"Response")
            //console.log(response)
            if (response?.success == true && response?.message?.length == 0) {
                if (response?.data?.length === 0) {
                    setVehicleDetail("")
                    setLoading(false)
                    toast.warning("Vehicle not found");
                    return
                }else{
                setVehicleDetail(response?.data[0])
                setOwnerName(response?.data[0]?.ownerName)
                setFlatIdOption(response?.data[0]?.flatId)
                setMyFlatName(response?.data[0]?.flatName);
                setTowerSelected(response?.data[0]?.towerId)
                setLoading(false)
                setTowerNameGet(response?.data[0]?.towerName)
                }
            }
            else {
                ToastContainer.error(response?.message[0] || "Vehicle not found");
                setVehicleDetail("")
                setLoading(false)
            }
        }
        catch (error) {
            setLoading(false)
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Tower/",
                "errorSource": "CuroNextPortal",
                "errorNumber": "UTI01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Utility.js",
                "functionName": "getVehicleDetailByNum",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.status === 200 & response?.message?.length == null) {
                alert("Something went wrong");
                setLoading(false);
            } else {
                alert("Something went wrong");
                setLoading(false);
            }
        }

    }
    //console.log(edit)

    async function saverOwnerShipData() {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        //console.log(myUserData)
        // setLoading(true);
        const endPointVariableKey = {
            buildingId: myUserData?.buildingId,
        }
        const bodyReq = {
            flatId: parseInt(flatId),
            modifiedUserId: myUserData?.userId?.toString(),
            ownerName: ownerName,
            vehicleId: vehicleDetail?.vehicleId
        }
        console.log(bodyReq, "BodyREQ")
        try {
            const response = await commonAPI("resetVehicleOwnerShip", bodyReq, endPointVariableKey)
            console.log(response, "RESPONSE")
            if (response.success == true) {
                toast.success("Vehicle Ownership is changed successfully")
                inputData.current.value = ""
                setVehicleDetail("")
                setEdit(false)
                setEditFlat(false)

            }
            else {
                toast.error(response?.message[0]);
            }
        }
        catch (error) {
            setLoading(false)
            setLoading(false)
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Tower/",
                "errorSource": "CuroNextPortal",
                "errorNumber": "UTI03",
                "errorSource": "CuroNextPortal",
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Utility.js",
                "functionName": "saverOwnerShipData",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.status === 200 & response?.message?.length == null) {
                alert("Something went wrong");
                setLoading(false);
            } else {
                alert("Something went wrong");
                setLoading(false);
            }
        }


    }
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                // Perform your action here
                // console.log(edit,editFlat)
                // if(!edit || !editFlat){
                //     saverOwnerShipData()
                // }


            }
        };

        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (<>
        {Loading ? (
            <div className="loaderDiv">
                <div className="loader"></div>
            </div>
        ) : null}
         <style>
        {`.css-1680m6m-DropDown {
            width: 200px;
        }
        
        .css-wmy1p7-ReactDropdownSelect{
            font-size: 13px;
            border-color: #ccc;
            border-radius: 4px;
            height: 30px;
            width: 105px;
            background-color: #fff;
            text-align: left;
        }
        .css-jznujr-ContentComponent {
            display: contents;
        }`
        
        }
        </style>

        <Menus />
        <section className="tabular_intergration" style={isMobile ? { ...mobileStyle,display:"none" }:mobileStyle}>
            <div className="tab-container">
                <div className="UnderBox-Shadow" style={{marginTop: "10px"}}>
                    <div className="container-fluid py-0 px-0">
                        <div className="row">
                            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                                <div className="tabs d-flex">
                                    <button
                                        className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                                        onClick={() => handleTabChange("tab1")}
                                    >
                                        <img src={vehicleOwner} className="img" style={{ width: "21px", marginRight: 5 }} />
                                        
                                        Manage Vehicle ownership
                                    </button>
                                    <button
                                    className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                                    onClick={() => handleTabChange("tab2")}
                                    >
                                        <img src={manageRfid} className="img" style={{ width: "21px", marginRight: 5 }} /> Manage Tag
                                    </button>
                                    <button
                                    className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                                    onClick={() => handleTabChange("tab3")}
                                    >
                                        <img src={ContactIcon} className="img" style={{ width: "21px", marginRight: 5 }} /> Manage Priority Contact
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section >
        <div className="mobileViewSubMenu" style={{width:"100%"}}>
            <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
                {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
                {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
            </div>
            <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
                <div className="row">

                    <div className="tabs">
                        <button
                            className={activeTab === "tab1 subfeildbtn" ? "active-tab" : "subfeildbtn active-tab"}
                            onClick={() => handleTabChange("tab1")}
                        >
                            
                            Manage Vehicle ownership
                        </button>
                        <button
                        className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                        onClick={() => handleTabChange("tab2")}
                        >
                            <img src={manageRfid} className="img" style={{ width: "21px", marginRight: 5 }} /> Manage Tag
                        </button>
                        <button
                        className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                        onClick={() => handleTabChange("tab3")}
                        >
                            <img src={manageRfid} className="img" style={{ width: "21px", marginRight: 5 }} /> Manage Priority Contact
                        </button>

                    </div>
                    

                </div>
            </div>
        </div>

        <section className="whole_bColor">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">

              <div>
                {activeTab === "tab1" && (
                  <div>
                    {Loading ? (
                        <div className="loaderDiv">
                            <div className="loader"></div>
                        </div>
                    ) : null}


                    <Menus />
                    <section className="section" onClick={() => {

                        setEdit(false);
                        setEditFlat(false);
                    }}>
                        <div className="parentContainer" style={isMobile ? { marginTop:90 }:{marginTop:117}  } >
                            <div className="">
                                {/* <label htmlFor="exampleInputEmail1"> Client Name :</label> */}
                                <input type="text" ref={inputData} placeholder="Enter Full Vehicle Number"></input>
                                <button className="VehicleSerchButton" onClick={() => { getVehicleDetailByNum(); }}> <FiSearch /> Search</button>
                            </div>
                        </div>
                        {vehicleDetail && vehicleDetail?.lpNumber ? <div className="detailSection">
                            {/* <div className="childSection">
                    <label>Active</label>
                    </div> */}
                            <div className="childSection">
                                <label>Owner Name</label> {edit && <input ref={inputRef} style={{padding: 8, border: "1px solid #ccc", borderRadius: 3}} onClick={(e) => { e.stopPropagation(); setEdit(true); }} value={ownerName} onChange={(e) => { setOwnerName(e.target.value); e.stopPropagation(); setEdit(true); }} type="text" />}{!edit && <span>{vehicleDetail?.ownerName} <IconContext.Provider value={{ className: "top-react-icons" }}><FaRegEdit onClick={(e) => { e.stopPropagation(); setEdit(true) }} /></IconContext.Provider></span>}
                            </div>
                            <div className="childSection">
                                <label>Flat Number </label>{editFlat && <>
                                <div className="utiselect">
                                {/* <select defaultValue={TowerSelected} onClick={(e) => {e?.stopPropagation(); setEditFlat(true); setTowerSelected(e?.target.value) }}>
                                    {TowerList?.map((item) => { return <option value={item?.towerId} >{item?.towerName}</option> })}
                                </select> 
                                <select defaultValue={flatId} onClick={(e) => { e?.stopPropagation(); setEditFlat(true); setFlatIdOption(e?.target.value) }}>
                                    {flat?.map((flatName) => { return <option value={flatName?.flatId} >{flatName?.flatName}</option> })}
                                </select> */}
                                <span
                                style={{width:"210px"}}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setEditFlat(true); // or any logic you need on click
                                    }}
                                    >
                               <Select
                                    options={
                                        TowerList
                                        ? TowerList.map(item => ({ value: item.towerId, label: item.towerName }))
                                        : []
                                    }
                                    clearable={TowerSelected ? true : false}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    className="sltareamodal"
                                    placeholder="Select Tower"
                                    values={
                                        TowerList && TowerSelected
                                        ? [
                                            {
                                                value: TowerSelected,
                                                label:
                                                TowerList.find(item => item.towerId == TowerSelected)?.towerName ||
                                                ""
                                            }
                                            ]
                                        : []
                                    }
                                    onChange={(values) => {
                                        // Simulate the same logic
                                        setEditFlat(true); // equivalent of onClick
                                        setTowerSelected(values?.[0]?.value || "");
                                        setFlatIdOption(""); // Reset flat
                                        setflat([]);
                                    }}
                                    style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: 30,
                                        width: 105,
                                        backgroundColor: '#fff',
                                        textAlign: 'left',
                                        marginRight: 10
                                        }}
                                        dropdownStyle={{
                                        width: '200px',
                                        // zIndex: 9999
                                        display: "contents"
                                        }}
                                    />
                                    
                                    <Select
                                        options={
                                            flat
                                            ? flat.map(flatName => ({
                                                value: flatName.flatId,
                                                label: flatName.flatName
                                                }))
                                            : []
                                        }
                                        clearable={flatId ? true : false}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        className="sltareamodal"
                                        placeholder="Select Flat"
                                        values={
                                            flat && flatId
                                            ? [
                                                {
                                                    value: flatId,
                                                    label:
                                                    flat.find(item => item.flatId == flatId)?.flatName || ""
                                                }
                                                ]
                                            : []
                                        }
                                        onChange={(values) => {
                                            // Simulates onClick and onChange in native select
                                            setEditFlat(true);
                                            setFlatIdOption(values?.[0]?.value || "");
                                        }}
                                        style={{
                                        fontSize: '13px',
                                        borderColor: '#ccc',
                                        borderRadius: '4px',
                                        height: 30,
                                        width: 105,
                                        backgroundColor: '#fff',
                                        textAlign: 'left',
                                        marginRight: 10
                                        }}
                                        dropdownStyle={{
                                        width: '200px',
                                        // zIndex: 9999
                                        display: "contents"
                                        }}
                                    />

                                </span>    

                                </div>
                                </>
                                }{!editFlat && <span>{TowerNameGet} - {myFlatName} <IconContext.Provider value={{ className: "top-react-icons" }}><FaRegEdit onClick={(e) => { e?.stopPropagation(); setEditFlat(true); }}></FaRegEdit></IconContext.Provider></span>}
                            </div>
                            <div className="childSection">
                                <label>Vehicle Number</label> <span>{vehicleDetail?.lpNumber}</span>
                            </div>

                            <div className="childSection">
                                <label>Tag Serial Number </label> <span>{vehicleDetail?.tagId}</span>
                            </div>
                            <div className="childSection">
                                <label>Brand </label> <span>{vehicleDetail?.brand}</span>
                            </div>
                            <div className="childSection">
                                <label>Vehicle Type </label> <span>{vehicleDetail?.vehicleType}</span>
                            </div>
                            <div className="childSection">
                                <label>Fuel type</label> <span>{vehicleDetail?.fuelType}</span>
                            </div>
                            <div className="childSection">
                                <label>Current Status</label> <span>{vehicleDetail?.currentStatus}</span>
                            </div>



                        </div> : <div className="detailSection noVehicle"><img src={vehicleDetail?.vehicleId === 0 ? noVehicle : noVehicle_Two} />
                            <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px", }}>{vehicleDetail?.vehicleId === 0 ? "No vehicle found" : "Manage vehicle ownership"}</h3>
                            <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}>{vehicleDetail?.vehicleId === 0 ? "Enter valid vehicle number to manage ownership" : "Enter vehicle number and click on search"} </h5>
                        </div>}
                        {(edit || editFlat) && (
                            <div className="showButtonDiv">
                                <button type="button" className="btn border bg-white m-0"> Cancel</button>
                                <button type="button" className="btn btn-info createClr" onClick={(e) => { e.stopPropagation(); setEditFlat(true); saverOwnerShipData() }}> Submit</button>
                            </div>
                            // <div className="lastDiv">
                            //     <button className="savePostButton" onClick={() => { saverOwnerShipData() }}>Save</button>
                            // </div>
                        )}
                    </section>
                    <ToastContainer />
                  </div>
                )}
                {activeTab === "tab2" && (
                  <div>
                    <ManageTag />
                  </div>
                )}
                {activeTab === "tab3" && (
                  <div>
                    <PriorityContact />
                  </div>
                )}
                
             
          
         
              </div>

            </div>
          </div>
        </div>
      </section>

    </>)
}
export default Utility